import React, { Children } from 'react'
import styled from 'styled-components'
import '../components/theme.js'

const FooterGroup = styled.div`
    background:linear-gradient(var(--GrayLevel7),var(--GrayLevel6));
    padding:50px 0;
    display:grid;
    grid-gap:24px;
    z-index:1;
    
    @media(max-width:640px){
        overflow:hidden
    }`
    
const Text = styled.h2`
    color:var(--GrayLevel2);
    font-weight:600;
    font-size:2em;
    max-width:640px;
    font-style:italic;
    margin:0 auto;`

const SubText = styled.p`
    text-align:center;
    font-size:16px;
    font-weight:bold;
    color:var(--GrayLevel4);
`

const DownloadGroup = styled.div`
    max-width:640px;
    margin:0 auto;
    display:grid;
    grid-template-columns:repeat(2,auto);
    grid-gap:12px;
    a{  
        text-decoration:none;
        font-size:0.8em;
        padding:2px;
    }
`

const Store = styled.div`
    display:grid;
    grid-template-rows:repeat(2,auto);
    grid-gap:4px;
    width:96px;
    font-size:1.6em;
    font-weight:600;
    color:var(--GrayLevel2);
    padding:12px 12px;
    border:0.5px solid var(--GrayLevel5);
    border-radius:12px;
    justify-self:center;
    transition: 2s cubic-bezier(0.15, 0.1, 0.1, 1);
    align-items:center;
    justify-items:center;
    text-decoration:none;
  
    &:hover{
        transform:scale(1.1,1.1)；
        box-shadow:0 12px 32px rgba(0,0,0,0.05);
        background:var(--White);
    }
    
    `
const LinkGroup = styled.div`
    display:grid;
    grid-template-columns:repeat(4,1fr);
    justify-items:center;
    align-items:center;
    max-width:480px;
    margin:0 auto;
    

    a{
    text-decoration:none;
    color:var(--GrayLevel1);
    font-size:1.4em;
    font-weight:600;
    padding:12px 8px;
    
}
    `

const Copyright = styled.div`

    color:var(--GrayLevel3);
    font-size:14px;
    max-width:640px;
    margin:0 auto;

    span{
        background:var(--Red);
        color:var(--WhitePatch1);
        font-weight:bold;
        font-size:10px;
        padding:4px 8px;
        border-radius:6px;
        line-height:2;
        box-shadow:0px 6px 24px rgba(255,0,0,0.10)
    }
    
`

const Footer = ({data,children}) =>(
    <FooterGroup>
        <Text> RED DESIGN ・ DARKMODE </Text>
        
        <SubText>Download Apps</SubText>
        <DownloadGroup>
            <a href="https://apps.apple.com/co/app/%E5%B0%8F%E7%BA%A2%E4%B9%A6-%E6%A0%87%E8%AE%B0%E6%88%91%E7%9A%84%E7%94%9F%E6%B4%BB/id741292507"><Store><img src={require('../images/apple-app-store.svg')} width="32" height=""></img>iOS</Store></a>
            <a href="https://play.google.com/store/apps/details?id=com.xingin.xhs"><Store><img src={require('../images/google-play.svg')} width="32" height="32"></img>Android</Store></a>
        </DownloadGroup>
        <LinkGroup>
            {data.allContentfulLink.edges.map(edge =>(
            <a href={edge.node.url}>{edge.node.title}</a>
            ))}
        </LinkGroup>
        <Copyright>{children}</Copyright>
    </FooterGroup>
)

export default Footer